var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"privacy_policy_link"}},[_c('router-link',{staticClass:" font-koho text-gray-500 text-base sm:text-xs lg:text-sm",attrs:{"to":"/privacy_policy"}},[_vm._v("PRIVACY POLICY")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }